import React from 'react';
import useManualRefinement from '../Controller/useManualRefinement.controller';
import {ContainerBox, ResponsiveBox} from '../Style/ManualRefinement.style';
import ManualRefinementImageList from '../../../Containers Components/ManualRefinementImageList/View/ManualRefinementImageList.view';
import {ManualRefinementReferenceDisplay} from '../../../Containers Components/ManualRefinementReferenceDisplay';
import {ThemeProvider} from '../../../ui-library';
import BeforeExitModalView from '../../../Containers Components/BeforeExitModal/View/BeforeExitModal.view';
import {_SYSTEM_TITLES} from '../../../configuration/SystemTitles/SystemTitles.config';
import MoveNextClassModal from '../../../Containers Components/MoveNextClassModal/View/MoveNextClassModal.view';
import WrongRequest from './WrongRequest.view';
import { FLOW } from '../../RandomSampler/Config/RandomSampler.constants';

const ManualRefinement = () => {
    const {goBackToAutoProject, isExitModal, setIsOpenExitModal, manualRefinementState, setState} = useManualRefinement();

    return (
        <ThemeProvider>
            <ContainerBox>
                {manualRefinementState.index > -1 && <ResponsiveBox
                    sx={{
                        flexDirection: { xs: 'column-reverse', md: 'row' },
                        alignItems: { lg: 'flex-start' }
                    }}>
                    <>
                        {manualRefinementState.isErrorPage ? <WrongRequest />
                            : <ManualRefinementImageList setState={setState} manualRefinementState={manualRefinementState} key='ManualRefinementImageList' flow={FLOW.autoProject}/>}
                        <ManualRefinementReferenceDisplay setState={setState} manualRefinementState={manualRefinementState} goBack={() => setIsOpenExitModal(true)} key='ManualRefinementReferenceDisplay'/>
                    </>
                </ResponsiveBox>}
            </ContainerBox>
            {manualRefinementState.index > -1 && <MoveNextClassModal className={manualRefinementState.index > -1 && manualRefinementState.classes[manualRefinementState.index].name} open={manualRefinementState.isMoveToAnotherClass} />}
            <BeforeExitModalView
                title={_SYSTEM_TITLES.manualRefinementExitModalTitle}
                content={_SYSTEM_TITLES.manualRefinementExitModalContent}
                yesTitle={_SYSTEM_TITLES.manualRefinementExitModalStayBtn}
                cancelTitle={_SYSTEM_TITLES.manualRefinementExitModalBackBtn}
                open={isExitModal}
                setOpen={setIsOpenExitModal}
                onClick={goBackToAutoProject}/>
        </ThemeProvider>
    );

};

export default ManualRefinement;
